export default __webpack_public_path__ + "static/media/icon-clear-off.f594b587.svg";